import {
  LiteDataModulePresenterModel,
  ReportPresenterModel,
} from '@osos/shared/types';

// tslint:disable-next-line: no-namespace
export namespace ReportsActions {
  export class FetchReport {
    static readonly type = '[Reports] Fetch Report';
    constructor(
      public payload: string,
      public cache = true,
    ) {}
  }
  export class FetchReports {
    static readonly type = '[Reports] Fetch Reports';
    constructor(
      public payload: {
        entityId: string;
        skip?: number;
        limit?: number;
        searchTerm?: string;
        filters?: { [key: string]: any };
        keepData?: boolean;
        filterBy?: string[];
      },
    ) {}
  }

  export class GetCountsByTypes {
    static readonly type = '[Reports] get counts by permission scoop';
    constructor(
      public payload: {
        entityId: string;
        searchTerm?: string;
        filter?: { [key: string]: any };
      },
    ) {}
  }

  export class FetchPinnedReports {
    static readonly type = '[Reports] Fetch Pinned Reports';
  }
  export class CreateReport {
    static readonly type = '[Reports] Create Report';
    constructor(public payload: ReportPresenterModel) {}
  }

  export class UpdateReport {
    static readonly type = '[Reports] Update Report';
    constructor(
      public payload: {
        id: string;
        report: ReportPresenterModel;
        moduleDetails: LiteDataModulePresenterModel;
      },
    ) {}
  }
  export class DeleteReport {
    static readonly type = '[Reports] Delete Report';
    constructor(
      public payload: {
        reportId: string;
        moduleDetails: LiteDataModulePresenterModel;
      },
    ) {}
  }

  export class TransitoryExportReport {
    static readonly type = '[Reports] Export Report';
    constructor(
      public payload: {
        reportId: string;
        filters: {};
        format: string;
        selectedColumns?: string[];
      },
    ) {}
  }

  export class SelectReport {
    static readonly type = '[Reports] Select Report';
    constructor(public payload: string) {}
  }
}
